export default __webpack_public_path__ + "static/media/man_in_the_wind_3.685f1dc2.png";